import { defineMessages } from 'react-intl';

export const howHeardTypeOptions = defineMessages({
  selectOne: {
    id: 'Heard.select',
    defaultMessage: 'Select one...',
    description: 'Default question option title',
  },
  defaultOption: {
    id: 'Heard.default',
    defaultMessage: 'How did you hear about us?',
    description: 'How heard title',
  },
  podcastTitle: {
    id: 'Heard.podcast',
    defaultMessage: 'Podcast',
    description: 'Podcast option title',
  },
  podcastDetail: {
    id: 'Heard.detail.which',
    defaultMessage: 'Which one?',
    description: 'Which detail question',
  },
  softwareTitle: {
    id: 'Heard.softwareIntegrationPartner',
    defaultMessage: 'Software Integration Partner',
    description: 'Software Integration Partner option title',
  },
  softwareDetail: {
    id: 'Heard.detail.which',
    defaultMessage: 'Which one?',
    description: 'Which detail question',
  },
  socialTitle: {
    id: 'Heard.socialMedia',
    defaultMessage: 'Social Media or Search',
    description: 'Social Media option title',
  },
  socialDetail: {
    id: 'Heard.detail.social',
    defaultMessage: 'Which platform?',
    description: 'Social detail question',
  },
  someoneTitle: {
    id: 'Heard.someone',
    defaultMessage: 'Someone told me',
    description: 'Someone option title',
  },
  someoneDetail: {
    id: 'Heard.detail.someone',
    defaultMessage: 'Who was it? We have gifts.',
    description: 'Someone detail question',
  },
  tradeTitle: {
    id: 'Heard.tradeShow',
    defaultMessage: 'Trade Show or Event',
    description: 'Trade Show option title',
  },
  tradeDetail: {
    id: 'Heard.detail.tradeShow',
    defaultMessage: 'What was it called?',
    description: 'Trade show detail question',
  },
  manufacturerTitle: {
    id: 'Heard.manufacturer',
    defaultMessage: 'Manufacturer or Industry Group',
    description: 'Manufacturer option title',
  },
  manufacturerDetail: {
    id: 'Heard.detail.manufacturer',
    defaultMessage: 'Can you tell us more?',
    description: 'Manufacturer detail question',
  },
  otherDetail: {
    id: 'Heard.detail.other',
    defaultMessage: 'Can you tell us more?',
    description: 'Other detail question',
  },
  howHeardTitle: {
    id: 'Heard.title',
    defaultMessage: 'How did you hear about us?',
    description: 'How Heard input placeholder',
  },
});
